import type { SignalFilters } from './useSignals';

export const buildSignalsRequestFilters = ({
  filters,
  rejectedOnly,
}: {
  filters: SignalFilters;
  rejectedOnly: boolean;
}): Record<string, unknown> => {
  if (rejectedOnly) {
    return {
      rejectedOnly: true,
      ...(filters.description && { description: filters.description }),
    };
  }

  const { category } = filters;

  return {
    ...(filters.stage !== 'ALL' && { stage: filters.stage }),
    ...(filters.status !== 'ALL' && { status: filters.status }),
    ...((filters.confirmedVulnerabilityFindingState?.length ?? 0) > 0 && {
      confirmedVulnerabilityFindingState:
        filters.confirmedVulnerabilityFindingState,
    }),
    ...((filters.blockedReason?.length ?? 0) > 0 && {
      blockedReason: filters.blockedReason,
    }),
    ...(filters.description && { description: filters.description }),
    ...(filters.confidence.length > 0 && { confidence: filters.confidence }),
    ...(category !== 'ALL' && {
      category: Array.isArray(category) ? category : [category],
    }),
    ...(filters.origin !== 'ALL' && { origin: filters.origin }),
    ...((filters.source?.length ?? 0) > 0 && { source: filters.source }),
    ...(filters.assigneeId.length > 0 && { assigneeId: filters.assigneeId }),
    ...(filters.url && { url: filters.url }),
    ...(filters.hasExecution !== undefined && {
      hasExecution: filters.hasExecution,
    }),
    ...(filters.hasFinding !== undefined && {
      hasFinding: filters.hasFinding,
    }),
    ...(filters.hasSecurityTestCase !== undefined && {
      hasSecurityTestCase: filters.hasSecurityTestCase,
    }),
    ...(filters.isAppWide !== undefined && { isAppWide: filters.isAppWide }),
    ...(filters.createdStartDate && {
      createdStartDate: filters.createdStartDate,
    }),
    ...(filters.createdEndDate && { createdEndDate: filters.createdEndDate }),
    ...(filters.testedStartDate && {
      testedStartDate: filters.testedStartDate,
    }),
    ...(filters.testedEndDate && { testedEndDate: filters.testedEndDate }),
    ...(filters.lifecycleState && { lifecycleState: filters.lifecycleState }),
  };
};
